<template>
  <div>
    <div
      v-if="
        this.$store.get('systems@LoginData') &&
          this.$store.get('systems@LoginData').userName &&
          this.$store.get('systems@LoginData') != []
      "
      class="offline-user-online text-align-center"
      v-bind:style="{
        top: `${this.$store.get('systems@PageHeight') - 26}px`,
        width: `200px`,
        left: `${this.$store.get('systems@PageWidth') - 210}px`
      }"
    >
      <v-icon name="user" class="icon-user-online"></v-icon
      >{{ this.$store.get("systems@LoginData").userName }}
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import store from "../store/store";

import VueOffline from "vue-offline";
Vue.use(VueOffline);

@Component({
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
    }
  }
})
export default class OnlineUser extends Vue {}
</script>

<style lang="scss">
.offline-user-online {
  background-color: #fc9842;
  background-image: linear-gradient(315deg, #fc9842 0%, #fe5f75 74%);
  text-align: center;
  font-size: 15px;
  position: fixed;
  z-index: 99999999;
  border-radius: 4px;
  color: #222222;
  top: 100px;
  line-height: 22px;
  left: 4px;
}

.icon-user-online {
  margin-top: -2px;
  width: 18px;
}

.online {
  background-color: #00b712;
  background-image: linear-gradient(315deg, #00b712 0%, #5aff15 74%);
  color: black;
}
</style>
